import type { FC } from 'react'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import type { Hit } from '@segment/api/algolia/client'
import type { Recipe } from '@segment/api/types/recipe'

import Card from '../Card'
import CardsGroup from '../CardsGroup'
import CardsSection from '../CardsSection'

interface RecipesGridProps {
  recipes: Hit<Recipe>[] | undefined
  isEmpty: boolean | undefined
  isLoading: boolean
  title: string | null
  nextPageTrigger: JSX.Element
}
const RecipesGrid: FC<RecipesGridProps> = ({ recipes, isEmpty, isLoading, title, nextPageTrigger }) => {
  return (
    <CardsSection isEmpty={isEmpty} isLoading={isLoading} title={title}>
      <CardsGroup data-testid="loading-overlay" aria-live="polite" aria-busy={isLoading}>
        {recipes?.map(({ title, authors, industries, teams, experienceLevel, description, slug }) => (
          <Card
            key={title}
            authors={authors}
            industries={industries}
            teams={teams}
            experienceLevel={experienceLevel}
            title={title}
            description={description}
            slug={slug}
          />
        ))}
        {isEmpty && (
          <CopyTextBase>
            <CopyText.Description variant="pMedium">
              Sorry, we couldn’t find any recipes that match the search criteria.
            </CopyText.Description>
          </CopyTextBase>
        )}
      </CardsGroup>
      {nextPageTrigger}
    </CardsSection>
  )
}

export default RecipesGrid
